<template>
  <div id="help">
    <div class="box">
      <div class="lv3Text t">购物流程</div>
      <div v-html="text" class="text"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      text: "",
      serve: this.$store.state.serve,

    };
  },
  watch: {},
  created() {
    this.initData();
  },
  methods: {
    //
    initData() {
      var that = this;
      this.axios.get(this.serve + "/help/help_center",{
         params:{
            id : '3'
         }
      }).then(res => {
        this.text = res.data.content;
      });
    }
  }
};
</script>
<style lang="scss">
#help {
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    .t {
      margin-bottom: 40px;
      margin-bottom: 40px;
      background: rgba(238, 238, 238, 1);
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      padding-left: 40px;
    }
    .text {
      line-height: 2em;
      padding: 0 20px;
      margin: 40px 0;
      img{
         max-width: 900px;
      }
    }
  }
}
</style>
